import { mapDebug } from '../utils/debug';

// Calculate midpoint between two points
export const calculateMidpoint = (point1, point2) => {
  return [
    (point1[0] + point2[0]) / 2,
    (point1[1] + point2[1]) / 2
  ];
};

// Format distance display
export const formatDistance = (distance) => {
  if (distance < 1) {
    return `${(distance * 1000).toFixed(0)}m`;
  }
  return `${distance.toFixed(2)}km`;
};

// Convert degrees to radians
export const toRad = (x) => {
  return x * Math.PI / 180;
};

// Calculate Manhattan distance between two points
export const manhattanDistance = (lat1, lon1, lat2, lon2) => {
  const latDiff = Math.abs(lat2 - lat1) * 111;
  const lngDiff = Math.abs(lon2 - lon1) * 111;
  return latDiff + lngDiff;
};

// Calculate total distance of entire path
export const calculatePathDistance = (path, locations) => {
  if (!path || path.length < 2 || !locations || locations.length === 0) {
    return 0;
  }
  
  let totalDistance = 0;
  
  for (let i = 0; i < path.length - 1; i++) {
    const current = locations.find(loc => loc.id === path[i]);
    const next = locations.find(loc => loc.id === path[i + 1]);
    
    if (current && next) {
      totalDistance += manhattanDistance(
        current.latitude, 
        current.longitude, 
        next.latitude, 
        next.longitude
      );
    }
  }
  
  return totalDistance;
};

// Helper function to safely update data source
export const safeSetSourceData = (map, mapReady, sourcesReady, sourceId, data) => {
  if (!map || !mapReady || !sourcesReady) {

    return false;
  }
  
  try {
    const source = map.getSource(sourceId);
    if (source) {
      // Try force refreshing the source
      try {
        // First attempt: normal update
        source.setData(data);

        return true;
      } catch (innerErr) {

        // Second attempt: try with timeout
        setTimeout(() => {
          try {
            source.setData(data);

          } catch (delayedErr) {

          }
        }, 100);
        
        return false;
      }
    } else {

    }
  } catch (err) {

  }
  return false;
}; 